export const BUILD_SERVICE_ENDPOINT = window.env.VUE_APP_BUILD_SERVICE_URL;

// Resource paths
export const DEPLOYMENT_RESOURCE_PATH = '/deployment';
export const ENVIRONMENT_RESOURCE_PATH = '/environment';
export const THEME_RESOURCE_PATH = '/theme';
